import {create} from 'zustand';
import {UseExamResultOperationStoreType} from './types';
import {DEFAULT_EXAM_RESULT_OPERATION_STATE} from './constants';

export const useExamResultOperationStore = create<UseExamResultOperationStoreType>(set => ({
	examResultOperationState: DEFAULT_EXAM_RESULT_OPERATION_STATE,
	setExamResultOperationState: exam => set({examResultOperationState: exam}),
	resetExamResultOperationState: () =>
		set({examResultOperationState: DEFAULT_EXAM_RESULT_OPERATION_STATE}),
}));
